// extracted by mini-css-extract-plugin
export var infoItem = "_qw-2";
export var title = "_qw-0";
export var value = "_qw-1";